import { ZollAPIService } from '../../../services/zollApi.service'
import { zollBaseURL } from '../../../services/api.service'
import { CadImportResponse } from '../store/cadImport.types'
import { APIError } from '../../submitChart/store/submitChart.types'

const cadImportUrl = `${zollBaseURL}/api/Cad/retrieve`

export class CadImportService extends ZollAPIService {
  async doCadImport(data: string | unknown): Promise<CadImportResponse> {
    return this.postWithError(cadImportUrl, data)
  }

  static createErrorResponse(responseMessage: string): CadImportResponse {
    const response: any = {
      success: false,
      failure: true,
      responseMessage,
    }

    return response
  }

  static printAPIError(error: APIError) {
    console.log('----------------------------------')
    console.log('START: APIError')
    console.log('----------------------------------')

    CadImportService.printAPIErrorInner(error, 1)

    console.log('----------------------------------')
    console.log('END: APIError')
    console.log('----------------------------------')
  }

  private static printAPIErrorInner(error: APIError, errorNumber: number) {
    console.log('-----------------')
    console.log(`Error number: ${errorNumber}`)
    console.log('-----------------')
    console.log(`Error message: ${error.message}`)
    console.log(`Error stackTrace: ${error.stackTrace ? error.stackTrace : 'none'}`)

    if (!error.cause) {
      console.log(`Error cause: none`)
    } else {
      CadImportService.printAPIErrorInner(error.cause, errorNumber + 1)
    }
  }
}
